import { LocalityModel } from "@/types/LocalityModel";
import { createLink } from "@/services/clean-string-service";
import Link from "next/link";
import { usePathname } from "next/navigation";

export function LocaliteCard({ localite }: { localite: LocalityModel }) {
  const pathname = usePathname();
  const href = createLink([pathname, `${localite.name}-${localite.id}`]);

  function checkIfSimilar(localite: LocalityModel): boolean {
    return localite.displayName.toLowerCase() != localite.commune.toLowerCase();
  }

  return (
    <Link key={`${localite.name}-${localite.id}`} href={`${href}`}>
      <div className="items-center space-x-3 px-2">
        <div className="flex min-w-0 justify-between">
          <p className="text-sm font-medium text-gray-900">
            {localite.displayName}{" "}
            {localite.commune && checkIfSimilar(localite) && (
              <span>({localite.commune})</span>
            )}
          </p>
          {localite.postalCodes.length <= 5 && (
            <div className="flex flex-wrap space-x-2">
              {localite.postalCodes.map((postalCode) => (
                <p
                  key={postalCode + localite.id}
                  className="text-sm font-medium text-gray-900"
                >
                  {postalCode}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
